import { createStore } from 'stimulus-store';

export const bundleStore = createStore({
    name: 'bundleStore',
    type: Object,
    initialValue: {}
});